var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"containerRef",staticClass:"frame-container"},[(!_vm.isLoaded || !_vm.canPlay)?_c('img',{attrs:{"src":require('@/assets/images/' + _vm.urlRoot + _vm.indexRange[0] + '.png'),"alt":"default img"}}):_c('img',{ref:"imgRef",attrs:{"alt":'frame animation'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }